'use client';

import { createTheme } from '@mantine/core';
import base from './base';

const theme = createTheme({
	...base,
	primaryShade: 9,
	colors: {
		igluBlack: [
			'#ffffff',
			'#e8e8e8',
			'#d0d0d0',
			'#b9b9b9',
			'#a1a1a1',
			'#8a8a8a',
			'#727272',
			'#5b5b5b',
			'#434343',
			'#2c2c2c',
		],
		igluTextPrimary: [
			'#ffffff',
			'#ececec',
			'#d8d8da',
			'#c5c5c7',
			'#b1b1b5',
			'#9e9ea2',
			'#8a8a90',
			'#77777d',
			'#63636b',
			'#505058',
		],
		igluPrimaryHover: [
			'#ffffff',
			'#e4e6e9',
			'#c9ccd3',
			'#aeb3bd',
			'#939aa7',
			'#778092',
			'#5c677c',
			'#414e66',
			'#263450',
			'#0b1b3a',
		],
		igluSidebarButtonHover: [
			'#ffffff',
			'#e6e7ea',
			'#cdd0d4',
			'#b4b8bf',
			'#9ba0aa',
			'#838994',
			'#6a717f',
			'#51596a',
			'#384254',
			'#1f2a3f',
		],
		igluPrimary: [
			'#ffffff',
			'#e5e8ed',
			'#ccd1da',
			'#b2bac8',
			'#99a3b6',
			'#7f8ca3',
			'#667591',
			'#4c5e7f',
			'#33476c',
			'#19305a',
		],
		igluTextSecondary: [
			'#ffffff',
			'#f4f5f7',
			'#eaebef',
			'#dfe1e7',
			'#d4d7df',
			'#caccd7',
			'#bfc2cf',
			'#b4b8c7',
			'#aaaebf',
			'#9fa4b7',
		],
		igluSecondary: [
			'#ffffff',
			'#f3f6f8',
			'#e8ecf1',
			'#dce3ea',
			'#d1d9e3',
			'#c5d0dd',
			'#bac6d6',
			'#aebdcf',
			'#a3b3c8',
			'#97aac1',
		],
		igluDisabledText: [
			'#ffffff',
			'#f7f9fb',
			'#f0f2f6',
			'#e8ecf2',
			'#e0e6ee',
			'#d9dfe9',
			'#d1d9e5',
			'#c9d3e1',
			'#c2ccdc',
			'#bac6d8',
		],
		igluBorder: [
			'#ffffff',
			'#fafbfc',
			'#f5f7fa',
			'#f1f4f7',
			'#ecf0f4',
			'#e7ecf2',
			'#e2e8ef',
			'#dee5ec',
			'#d9e1ea',
			'#d4dde7',
		],
		igluTextButton: [
			'#ffffff',
			'#f8fbff',
			'#f1f6fd',
			'#e9f1fb',
			'#e2ecf9',
			'#dae6f7',
			'#d3e1f5',
			'#cbdbf3',
			'#c4d6f1',
			'#d2e0f4',
		],
		igluInnerForm: [
			'#ffffff',
			'#fdfeff',
			'#fcfcfe',
			'#fafbfe',
			'#f8fafd',
			'#f7f8fd',
			'#f5f7fc',
			'#f3f6fc',
			'#f2f4fb',
			'#f0f3fb',
		],
		igluBackground: [
			'#ffffff',
			'#fefeff',
			'#fcfdfe',
			'#fbfcfe',
			'#f9fbfd',
			'#f8fbfd',
			'#f6fafc',
			'#f5f9fc',
			'#f3f8fb',
			'#f2f7fb',
		],
		igluSurface: [
			'#ffffff',
			'#ffffff',
			'#ffffff',
			'#fefefe',
			'#fefefe',
			'#fefefe',
			'#fefefe',
			'#fdfdfd',
			'#fdfdfd',
			'#fdfdfd',
		],
		igluRed: [
			'#ffffff',
			'#ffe9e6',
			'#ffd3cd',
			'#ffbdb3',
			'#ffa79a',
			'#ff9081',
			'#ff7a68',
			'#ff644e',
			'#ff4e35',
			'#ff381c',
		],
		igluRedMid: [
			'#ffffff',
			'#fff8fa',
			'#fff1f4',
			'#feeaef',
			'#fee3e9',
			'#fedbe4',
			'#fed4de',
			'#fdcdd9',
			'#fdc6d3',
			'#fdbfce',
		],
		igluRedLight: [
			'#ffffff',
			'#fffcfd',
			'#fff9fb',
			'#fff6f8',
			'#fff3f6',
			'#fef1f4',
			'#feeef2',
			'#feebef',
			'#fee8ed',
			'#fee5eb',
		],
		igluGreen: [
			'#ffffff',
			'#e8f4ed',
			'#d0e9db',
			'#b9dec9',
			'#a1d3b7',
			'#8ac8a6',
			'#72bd94',
			'#5bb282',
			'#43a770',
			'#2c9c5e',
		],
		igluGreenMid: [
			'#ffffff',
			'#f7fefb',
			'#f0fcf7',
			'#e8fbf3',
			'#e0faef',
			'#d9f8ea',
			'#d1f7e6',
			'#c9f6e2',
			'#c2f4de',
			'#baf3da',
		],
		igluGreenLight: [
			'#ffffff',
			'#fbfefd',
			'#f7fefb',
			'#f4fdf9',
			'#f0fcf7',
			'#ecfcf5',
			'#e8fbf3',
			'#e5faf1',
			'#e1faef',
			'#ddf9ed',
		],
		igluBlue: [
			'#ffffff',
			'#edf1fd',
			'#dce2fb',
			'#cad4fa',
			'#b9c6f8',
			'#a7b7f6',
			'#96a9f4',
			'#849bf3',
			'#738cf1',
			'#617eef',
		],
		igluBlueLight: [
			'#ffffff',
			'#fcfeff',
			'#f8fdff',
			'#f5fbff',
			'#f2faff',
			'#eef9ff',
			'#ebf8ff',
			'#e8f6ff',
			'#e4f5ff',
			'#e1f4ff',
		],
		igluYellow: [
			'#ffffff',
			'#fef9e4',
			'#fdf3c9',
			'#fcedad',
			'#fbe792',
			'#fbe177',
			'#fadb5c',
			'#f9d540',
			'#f8cf25',
			'#f7c90a',
		],
		igluYellowLight: [
			'#ffffff',
			'#fffefb',
			'#fffcf7',
			'#fffbf3',
			'#fff9ef',
			'#fff8ec',
			'#fff6e8',
			'#fff5e4',
			'#fff3e0',
			'#fff2dc',
		],
	},
});

export default theme;
